module.exports = __webpack_public_path__ + "img/logo_golden.d4262788.svg";